import { $api } from '@/shared/api/axiosInstance';

type ResponseType = {
    code: 200;
    data: {
        firstName: string;
        lastName: string;
        patronymic: string;
        disabilityGroup: null | string;
        phone: string;
        email: string;
        birthDate: string;
        cachedUser: {
            id: string;
            calculation: number;
            disabilityGroup: number;
            debt: number;
            policyStartDate: string;
            birthDate: string;
            gender: string;
        };
        inn: string;
        drivingLicense: string;
        placeOfBirth: string;
        snils: string;
        passport: {
            serial: string;
            number: string;
            dateIssued: string;
            issuerCode: string;
            statusActive: boolean;
            issuedBy: string;
        };
        actualAddress: {
            uuid: string | null;
            fullAddress: string;
            fiasCode: string;
            postIndex: string;
            country: string;
            region: string;
            district: string;
            city: string;
            settlement: string;
            street: string;
            house: string;
            building: string | null;
            bulk: string;
            apartment: string;
            typeAddress: string;
        };
        postAddress: {
            uuid: string | null;
            fullAddress: string;
            fiasCode: string;
            postIndex: string;
            country: string;
            region: string;
            district: string;
            city: string;
            settlement: string;
            street: string;
            house: string;
            building: string | null;
            bulk: string;
            apartment: string;
            typeAddress: string;
        };
        policy: null;
        creditInfo: null;
    };
    errors: null;
    exception: null;
};

export const oAuthQuery = async ({ id, code }: { id: string | undefined; code: string }) => {
    const { data } = await $api.post<ResponseType>(
        `/api/v1/policy/user/sber/user`,
        { code },
        {
            headers: {
                'X-Guid': id,
            },
        }
    );

    return data;
};
